import { useEffect, useState } from "react";
import { Slot } from "../data/interfaces";
import moment from "moment";
import _environment from "../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------

function useSlots() {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [slots, setSlots] = useState<Slot[]>([]);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * @function
   * Setup slots for team member availability one time.
   */
  const setupStandMemberSlots = (): void => {
    const RES: Slot[] = [];
    const FAIR_START_DATE: moment.Moment = moment(_environment.fairStartdate);
    const FAIR_END_DATE: moment.Moment = moment(_environment.fairEndDate);
    const APPOINTMENTS_START_TIME = moment(_environment.appointments.startTime, "HH:mm");
    const APPOINTMENTS_END_TIME = moment(_environment.appointments.endTime, "HH:mm");

    // Iterate each day while fair is running
    for (
      let iteratedDay = FAIR_START_DATE.clone().set({ hour: 0, minute: 0 });
      iteratedDay.diff(FAIR_END_DATE, "days") <= 0;
      iteratedDay.add(1, "days")
    ) {
      // If the initial and final times coincide (e.g. from midnight to midnight)
      // add 1 day to the end date, otherwise there would be no iterations
      let endDate = APPOINTMENTS_START_TIME.isSame(APPOINTMENTS_END_TIME)
        ? iteratedDay.clone().add(1, "day")
        : iteratedDay.clone();

      // Subtract "duration" minutes from the end date, otherwise hed'd also consider
      // the slot that starts at the end of the fair.
      endDate = endDate
        .set({
          hour: APPOINTMENTS_END_TIME.hours(),
          minute: APPOINTMENTS_END_TIME.minutes(),
        })
        .subtract(_environment.appointments.duration, "minutes");

      // Set iterated start datetime
      const ITERATED_START_DATETIME = iteratedDay.clone().set({
        hour: APPOINTMENTS_START_TIME.hours(),
        minute: APPOINTMENTS_START_TIME.minutes(),
      });

      // Iterate timing in slot of "duration" minutes
      for (
        let iteratedSlot = ITERATED_START_DATETIME;
        iteratedSlot.diff(endDate, "minutes") <= 0;
        iteratedSlot.add(_environment.appointments.duration, "minutes")
      ) {
        // Consider this slot only if it's included within the fair duration
        if (iteratedSlot.isBetween(FAIR_START_DATE, FAIR_END_DATE)) {
          RES.push({
            day: iteratedDay.toISOString(true),
            start_datetime: iteratedSlot.toISOString(true),
            duration: _environment.appointments.duration,
          });
        }
      }
    }
    setSlots(RES);
  };

  /**
   * Get slots by day.
   * @function
   *
   * @param day
   */
  const getSlotsByDay = (day: moment.Moment): Slot[] => {
    return slots.filter((x: Slot) => x.day === day.toISOString(true));
  };

  /**
   * Retrieve free slots according to the day and members' commitments
   * @function
   *
   * @param day
   * @param membersCommitments
   */
  const getFreeSlotsByDay = (day: moment.Moment, membersCommitments: string[]): Slot[] => {
    const DAY_SLOTS: Slot[] = getSlotsByDay(day);
    return DAY_SLOTS.filter(
      (slot) => membersCommitments.indexOf(`${moment(slot.start_datetime).unix()}`) === -1,
    );
  };

  /**
   * Retrieve slot end moment object
   * @function
   *
   * @param slot
   */
  const getSlotEndDateTime = (slot: Slot): moment.Moment => {
    return moment(slot.start_datetime).clone().add(slot.duration, "minutes");
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[UseSlot] init");

    setupStandMemberSlots();
  };
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[UseSlot] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  return { slots, getFreeSlotsByDay, getSlotEndDateTime };
}

export default useSlots;
